import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "material-selector"
}
const _hoisted_2 = { class: "material-grid" }
const _hoisted_3 = ["onClick", "aria-label"]
const _hoisted_4 = { class: "material-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.availableMaterials.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableMaterials, (material) => {
            return (_openBlock(), _createElementBlock("div", {
              key: material.id,
              class: "material-item"
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (!_ctx.isLoading && _ctx.selectMaterial(material.id)),
                class: _normalizeClass([
            'material-preview',
            {
              active: _ctx.currentMaterial === material.id,
              disabled: _ctx.isLoading
            }
          ]),
                style: _normalizeStyle(_ctx.getMaterialStyle(material.id)),
                "aria-label": material.displayName
              }, null, 14, _hoisted_3),
              _createElementVNode("div", _hoisted_4, _toDisplayString(material.displayName), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}